<script setup>
/**
 * Se usa en los filtros de los listados
 */
import { ref, watch } from 'vue';
import { orderBy } from 'lodash';
import servicios from '../../api/cifra/servicios/servicios';
import SelectCifra from '../inputs/SelectCifra.vue';

const props = defineProps({
  multiple: { type: Boolean, default: true },
  modelValue: { type: Array, default: () => ([]) },
});

const emits = defineEmits(['update:modelValue']);

const modelInterno = ref(props.modelValue);

const options = ref([]);

servicios.servicios().then((result) => {
  // TODO: Revisar que no funcionará bien las tildes
  const data = orderBy(result.data, [(item) => item.nombre.toLowerCase()]);
  data.forEach((servicio) => {
    const servicioCursos = servicio.servicio_cursos;
    servicioCursos.forEach((servicioCurso) => {
      servicioCurso.textoParaFiltrar = `${servicio.nombre} - ${servicioCurso.nombre}`;
    });

    servicio.servicio_cursos = orderBy(
      servicioCursos,
      (item) => item.nombre.toLowerCase(),
    );
  });
  options.value = data;
});

watch(modelInterno, (value) => {
  emits('update:modelValue', value);
});

function customLabel(option, _label) {
  return option.textoParaFiltrar;
}
</script>

<template>
  <SelectCifra
    v-model="modelInterno"
    v-bind="$attrs"
    :opciones="options"
    :multiple="multiple"
    campo-etiqueta="nombre"
    campo-id="id"
    valores-grupo="servicio_cursos"
    etiqueta-grupo="nombre"
    :seleccionar-grupo="true"
    :mostrar-limpiar="multiple"
    :etiqueta-personalizada="customLabel"
  />
</template>
